import React from 'react';
import classNames from 'classnames';

type TabButtonProps = {
  title: string;
  selected: boolean;
  controls: string;
  onClick: () => void;
};

const TabButton = ({onClick, title, selected, controls}: TabButtonProps) => (
  <button
    onClick={onClick}
    className={classNames('TabButton', {'TabButton--selected': selected})}
    role='tab'
    aria-selected={selected}
    aria-controls={`${controls}-tab`}>
    {title}
  </button>
);

export default TabButton;
